import React, { useState, useCallback } from "react";
import { Form, Image, Button, Checkbox } from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useCategory } from "../../../../hooks";
import "./AddEditCategoryForm.scss";

export function AddEditCategoryForm(props) {
  const { onClose, onRefetch, category } = props;
  const [previewImage, setPreviewImage] = useState(category?.image || null);
  const { addCategory, updateCategory } = useCategory();

  const formik = useFormik({
    initialValues: initialValues(category),
    validationSchema: Yup.object(category ? updateSchema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (category) await updateCategory(category.id, formValue);
        else await addCategory(formValue);

        onRefetch();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const onDrop = useCallback(async (acceptedFile) => {
    const file = acceptedFile[0];
    await formik.setFieldValue("image", file);
    setPreviewImage(URL.createObjectURL(file));
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/jpeg, image/png",
    noKeyboard: true,
    multiple: false,
    onDrop,
  });

  return (
    <Form className="add-edit-category-form" onSubmit={formik.handleSubmit}>
      <Form.Input
        name="title"
        placeholder="Nombre de la categoria"
        value={formik.values.title}
        onChange={formik.handleChange}
        error={formik.errors.title}
      />

      <Form.Input
        name="order"
        type="number"
        min="0"
        label="Orden de aparición"
        placeholder="0"
        value={formik.values.order}
        onChange={formik.handleChange}
        error={formik.errors.order}
      />

      {/* Texto libre con sugerencias: cada local nombra sus áreas como quiera. */}
      <Form.Input
        name="production_area"
        label="Área de producción (opcional)"
        placeholder="Ej: Cocina, Bar, Ceviches"
        list="production-area-options"
        value={formik.values.production_area}
        onChange={formik.handleChange}
      />
      <datalist id="production-area-options">
        <option value="Cocina" />
        <option value="Bar" />
        <option value="Ceviches" />
        <option value="Parrilla" />
        <option value="Postres" />
      </datalist>

      <div className="add-edit-category-form__active">
        <Checkbox
          toggle
          checked={formik.values.active}
          onChange={(_, data) => formik.setFieldValue("active", data.checked)}
        />
        Categoría activa
      </div>

      <Button
        type="button"
        fluid
        color={formik.errors.image && "red"}
        {...getRootProps()}
      >
        {previewImage ? "Cambiar imagen" : "Subir imagen"}
      </Button>
      <input {...getInputProps()} />
      <Image src={previewImage} fluid />

      <Button
        type="submit"
        primary
        fluid
        content={category ? "Actualizar" : "Crear"}
      />
    </Form>
  );
}

function initialValues(data) {
  return {
    title: data?.title || "",
    order: data?.order ?? 0,
    active: data ? Boolean(data.active) : true,
    production_area: data?.production_area || "",
    image: "",
  };
}

function newSchema() {
  return {
    title: Yup.string().required(true),
    order: Yup.number().min(0),
    active: Yup.boolean().required(true),
    image: Yup.string().required(true),
  };
}

function updateSchema() {
  return {
    title: Yup.string().required(true),
    order: Yup.number().min(0),
    active: Yup.boolean().required(true),
    image: Yup.string(),
  };
}
